import { IconButtonProps } from '@mui/material';
import { lighten, useTheme } from '@mui/material/styles';
import { DeleteForeverOutlinedIcon } from '@occc-app/design-system';
import IconButton from '@mui/material/IconButton';

export interface IDeleteIconProps {
  onClick: () => void;
  sx?: IconButtonProps['sx'];
}

export const DeleteIcon = ({ onClick, sx }: IDeleteIconProps) => {
  const theme = useTheme();
  return (
    <IconButton
      onClick={onClick}
      size='medium'
      color='secondary'
      sx={{
        color: 'error.main',
        backgroundColor: lighten(theme.palette.error.main, 0.9),
        '&:hover': {
          backgroundColor: lighten(theme.palette.error.main, 0.7),
        },
        borderRadius: 2,
        p: 0.5,
        ...sx,
      }}
    >
      <DeleteForeverOutlinedIcon color='inherit' />
    </IconButton>
  );
};
